import { useMemo } from "react";
import type { ClipStatusTimeline } from "MVVM/Components/ClipStatus/@types";

export type TrayEntry =
  | { kind: "clips"; timelines: ClipStatusTimeline[] }
  | { kind: "montage"; montageId: string; timelines: ClipStatusTimeline[] }
  | { kind: "vod"; montageId: string; timelines: ClipStatusTimeline[] };

export const useClipStatusRegistry = (
  clips: ClipStatusTimeline[],
  dismissed: Record<string, number>,
): TrayEntry[] => {
  return useMemo(() => {
    const montageMap = new Map<string, ClipStatusTimeline[]>();
    const standaloneClips: ClipStatusTimeline[] = [];

    for (const clip of clips) {
      if (dismissed[clip.trackId] || dismissed[clip.montageId ?? ""]) continue;

      if (
        ["MONTAGE", "FULL_MATCH_VOD"].includes(clip.contentType ?? "") &&
        !clip.montageId
      )
        continue;

      if (clip.montageId) {
        const existing = montageMap.get(clip.montageId);
        if (existing) {
          existing.push(clip);
        } else {
          montageMap.set(clip.montageId, [clip]);
        }
      } else {
        standaloneClips.push(clip);
      }
    }

    const entries: TrayEntry[] = [];

    if (standaloneClips.length > 0) {
      entries.push({ kind: "clips", timelines: standaloneClips });
    }

    for (const [montageId, timelines] of montageMap) {
      const isVod = timelines.some((t) => t.contentType === "FULL_MATCH_VOD");
      entries.push({ kind: isVod ? "vod" : "montage", montageId, timelines });
    }

    return entries;
  }, [clips, dismissed]);
};
